const createDebounce = () => {
  let timeout = null;
  return (fnc, delayMs = 500) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fnc();
    }, delayMs || 500);
  };
};

export default createDebounce;
